var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{staticClass:"modal modal-message-ajax fade",attrs:{"tabindex":"-1","ok-variant":"ok","id":"front-page-modal-ajax","title":_vm.message.title,"ok-only":"","hide-backdrop":""},on:{"ok":_vm.ok}},[_c('p',{staticClass:"my-4",domProps:{"textContent":_vm._s(_vm.message.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }